export default __webpack_public_path__ + "static/media/pattern_react.01996482.png";